import { THM_USER_ID_KEY } from 'src/common/constants';
import { gb } from 'src/common/growthbook';
import type { LeaguesTier } from 'src/features/weekly-leagues/weekly-leagues.types';
import type { SocialPlatformId } from '../social-share.constants';

const DEFAULT_PARAMS = new URLSearchParams({
  utm_campaign: 'social_share',
  utm_medium: 'social',
});

export function addShareSearchParams(baseUrl: string, extraParams: SocialShareSearchParams): string {
  const url = new URL(baseUrl);

  for (const [key, value] of DEFAULT_PARAMS.entries()) {
    if (!url.searchParams.has(key)) {
      url.searchParams.set(key, value);
    }
  }

  for (const [key, value] of Object.entries(extraParams)) {
    url.searchParams.set(key, value);
  }

  const isSharerIdEnabled = gb.isOn('tracking-sharer-id');
  if (isSharerIdEnabled && typeof window !== 'undefined' && 'localStorage' in window) {
    const sharerId = window.localStorage.getItem(THM_USER_ID_KEY);
    if (sharerId) url.searchParams.set('sharerId', sharerId);
  }

  return url.toString();
}

/**
 * Serves to document all possible values across the application.
 *
 * Params maintain their casing.
 */
export interface SocialShareSearchParams {
  utm_content:
    | 'badge'
    | 'room'
    | 'streak'
    | 'certificate'
    | 'learning-path'
    | 'module'
    | 'task'
    | 'video'
    | 'text'
    | 'invite_link'
    | 'recapme24'
    | 'sec_eng'
    | 'red_teamer'
    | 'pentester'
    | 'incident_responder'
    | 'cs_analyst'
    | 'share-completed-room'
    | LeagueTierWin;

  utm_source: SocialPlatformId | 'copy';
  utm_campaign?: 'invite';
  // utm_medium?: string;
}
type LeagueTierWin = `${LeaguesTier}-league-win`;
